import { css, SerializedStyles } from '@emotion/core';
import { media } from '@domain-group/fe-brary';

// eslint-disable-next-line import/prefer-default-export
export const processTryButton = css`
  ${media('<tablet')} {
    width: 100%;
  }
  border: 1px solid #0ea800;
  color: #0ea800;
`;

export const processList = css`
  padding-top: 17px;
  padding-bottom: 42px;
  ${media('>=tablet')} {
    padding-top: 32px;
    display: flex;
  }
  counter-reset: landing-process-counter;
`;

export const processListItem = (isOpen: boolean): SerializedStyles => css`
  position: relative;
  ${media('<tablet')} {
    cursor: pointer;
    width: 100%;
    min-height: 66px;
    padding-top: 18px;
  }
  ${media('>=tablet')} {
    .domain-icon {
      display: none;
    }
    padding-top: 34px;
    border-top: 3px solid #20bbb5;
  }
  padding-right: 24px;
  :last-child {
    border-top: none;
    padding-right: 0px;
  }

  counter-increment: landing-process-counter;
  ::before {
    background-color: #fff;
    display: inline-block;
    ${media('>=tablet')} {
      position: absolute;
      top: -18px;
    }

    content: counter(landing-process-counter);
    border-radius: 50%;
    padding-top: 3px;
    width: 36px;
    height: 36px;
    border: 3px solid #20bbb5;
    box-sizing: border-box;
    color: #20bbb5;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
  }

  span {
    ${media('<tablet')} {
      position: absolute;
      top: 24px;
    }
    display: flex;
    justify-content: space-between;
    width: 100%;
    h3 {
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      ${media('<tablet')} {
        padding-left: 54px;
        display: inline-block;
      }
    }
  }

  p {
    display: none;
    ${isOpen && `display: block;`};
    padding-top: 18px;
    padding-left: 54px;
    padding-bottom: 33px;
    ${media('>=tablet')} {
      display: block;
      max-width: 217px;
      padding-left: 0px;
      padding-bottom: 0px;
    }
    ${media('>=desktop')} {
      max-width: 224px;
    }
  }
`;
